// Reduz a foto no aparelho antes do upload (R271, docs/07-issues.md). A foto
// sai crua da câmera (3-5 MB, 12 MP) e o backend já reduz pra 1920px de
// qualquer jeito (app/utils/checkin_photo.py): reduzir aqui corta o upload
// pra algumas centenas de KB (check-in mais rápido no 4G da academia) e tira
// CPU do servidor. Qualquer falha devolve o arquivo original: o backend
// continua reduzindo, então nunca é pior do que antes.

export const MAX_DIM = 1920;
export const JPEG_QUALITY = 0.85;
// Abaixo disso não vale o custo de decodificar no aparelho.
export const MIN_BYTES_TO_COMPRESS = 600 * 1024;

async function decode(file) {
  if (typeof createImageBitmap === "function") {
    // imageOrientation: aplica a rotação do EXIF (foto de celular em pé).
    return createImageBitmap(file, { imageOrientation: "from-image" });
  }
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    return img;
  } finally {
    URL.revokeObjectURL(url);
  }
}

export function targetSize(width, height, maxDim = MAX_DIM) {
  const scale = Math.min(1, maxDim / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

export async function compressImage(file, { maxDim = MAX_DIM, quality = JPEG_QUALITY, minBytes = MIN_BYTES_TO_COMPRESS } = {}) {
  if (!file || !/^image\//.test(file.type || "") || file.size < minBytes) return file;
  try {
    const source = await decode(file);
    const { width, height } = targetSize(source.width, source.height, maxDim);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(source, 0, 0, width, height);
    if (typeof source.close === "function") source.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
    if (!blob || blob.size >= file.size) return file;
    const name = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
  } catch {
    return file;
  }
}
